import { getTestAttributes, slug } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';

import { dateFormat } from '../../../../../../__util__/dates';

export function TemplateVersionInfo(props) {
  const { formTemplate, accountTimezone } = props;
  const { version_number: versionNumber } = formTemplate;

  const generateTemplateInfo = () => {
    return [
      {
        title: 'Version',
        content: versionNumber,
      },
      {
        title: 'Administrator',
        content: formTemplate.created_by ? formTemplate.created_by.email : '',
      },
      {
        title: 'Date',
        content: dateFormat(formTemplate.created_at, { timezone: accountTimezone }),
      },
      {
        title: 'Update Reason',
        content: formTemplate.reason_for_change,
      },
    ];
  };

  return (
    <div className="templateVersionInfo">
      {formTemplate &&
        generateTemplateInfo().map((info) => (
          <div key={info.title} className="templateVersionInfo__container">
            <div className="templateVersionInfo__title">{info.title}</div>
            <div className="templateVersionInfo__content" {...getTestAttributes(`${slug(info.title)}-info`)}>
              {info.content === '' ? 'Initial Version' : info.content}
            </div>
          </div>
        ))}
    </div>
  );
}

TemplateVersionInfo.propTypes = {
  formTemplate: PropTypes.shape({
    version_number: PropTypes.number,
    created_by: PropTypes.shape({
      email: PropTypes.string,
    }),
    created_at: PropTypes.string,
    reason_for_change: PropTypes.string,
  }).isRequired,
  accountTimezone: PropTypes.string.isRequired,
};

export default TemplateVersionInfo;
